module.exports = __webpack_public_path__ + "static/media/2.a67a24cc.jpg";